import React from 'react';

interface DialogActionsProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * DialogActions component for use with Dialog - provides a styled container for dialog buttons
 */
const DialogActions: React.FC<DialogActionsProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className={`px-6 py-4 bg-gray-50 dark:bg-gray-700 flex justify-end space-x-2 rounded-b-lg ${className}`}>
      {children}
    </div>
  );
};

export default DialogActions;